module.exports = __webpack_public_path__ + "img/refuse.70404d29.png";